import { REGISTER } from "@/constants/LocalStorageStoreKeys";
import { create } from "zustand";
import { persist, PersistOptions } from "zustand/middleware";

interface RegisterState {
    fullName: string
    email: string;
    password: string;
}

interface RegisterActions {
    setRegisterData: (data: RegisterState) => void
    setFullName: (fullName: string) => void
}

type RegisterStoreModel = RegisterState & RegisterActions

// eslint-disable-next-line
type RegisterStore = (set: any) => RegisterStoreModel

const store: RegisterStore = (set) => ({
    fullName: "",   
    email: "",
    password: "",
    setRegisterData: (data: RegisterState) => set({ 
        fullName: data.fullName,
        email: data.email,
        password: data.password,
    }),

    setFullName: (fullName: string) => set({
        fullName: fullName
    })
});

const persistOptions: PersistOptions<RegisterStoreModel> =  {
    name: REGISTER
}

const useRegister = create<RegisterStoreModel>()(
    persist(store, persistOptions)
);

export default useRegister;